export default __webpack_public_path__ + "static/media/buisness.8760f230.jpeg";